import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SettingsIcon } from '@primer/octicons-react';
import queryString from 'query-string';

import { chunksType, publicationMatchType, queryType } from '../../lib/types';

import styles from './ControlPanel.module.css';

const min = (a, b) => (a < b ? a : b);
const max = (a, b) => (a > b ? a : b);

const getFbcnlFromNumbers = (chunk, numbers) => {
  const index = numbers.indexOf(chunk);

  return [
    numbers[0],
    numbers[max(0, index - 1)],
    chunk,
    numbers[min(numbers.length - 1, index + 1)],
    numbers[numbers.length - 1],
  ];
};

class ControlPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refIsOpen: false,
      settingsIsOpen: false,
    };

    this.getLines = this.getLines.bind(this);
    this.getFbcnl = this.getFbcnl.bind(this);
    this.createLink = this.createLink.bind(this);
    this.toggleRefOpen = this.toggleRefOpen.bind(this);
    this.toggleSettingsOpen = this.toggleSettingsOpen.bind(this);
    this.renderSettingsLinks = this.renderSettingsLinks.bind(this);
    this.renderBack = this.renderBack.bind(this);
    this.renderNext = this.renderNext.bind(this);
  }

  getLines() {
    const { chunks: { start, end, numbers } } = this.props;

    if (numbers) {
      return numbers;
    }

    const lines = [];
    for (let ii = start; ii <= end; ii += 1) {
      lines.push(ii);
    }

    return lines;
  }

  getFbcnl() {
    const { chunks: { start, end, numbers }, match } = this.props;
    const { params: { chunk } } = match;
    const index = Number(chunk);

    if (numbers) {
      return getFbcnlFromNumbers(chunk, numbers);
    }

    return [
      start,
      max(start, index - 1),
      chunk,
      min(end, index + 1),
      end,
    ];
  }

  createLink(to) {
    const { linkQuery } = this.props;
    const link = `./${to}`;

    if (Object.entries(linkQuery).length > 0) {
      const query = queryString.stringify(linkQuery);

      return `${link}?${query}`;
    }

    return link;
  }

  toggleRefOpen() {
    this.setState(({ refIsOpen }) => ({ refIsOpen: !refIsOpen }));
  }

  toggleSettingsOpen() {
    this.setState(({ settingsIsOpen }) => ({ settingsIsOpen: !settingsIsOpen }));
  }

  renderSettingsLinks() {
    const { fullQuery } = this.props;
    const { config } = fullQuery;
    const newConfig = config === 'sidepanel' ? 'default' : 'sidepanel';
    const text = config === 'sidepanel' ? 'Hide morphology' : 'Show morphology';

    return (
      <a
        href={`?${queryString.stringify({ ...fullQuery, config: newConfig })}`}
        className="dropdown-item"
      >
        {text}
      </a>
    );
  }

  renderBack(first, back, current) {
    const visibility = current === String(first) ? ' invisible' : '';

    return (
      <>
        <li className={`nav-item${visibility}`}>
          <Link className={`nav-link text-light ${styles.link}`} to={this.createLink(first)}>
            &laquo; First
          </Link>
        </li>
        <li className={`nav-item${visibility}`}>
          <Link className={`nav-link text-light ${styles.link}`} to={this.createLink(back)}>
            &#8249; Back
          </Link>
        </li>
      </>
    );
  }

  renderNext(current, next, last) {
    const visibility = current === String(last) ? ' invisible' : '';

    return (
      <>
        <li className={`nav-item${visibility}`}>
          <Link className={`nav-link text-light ${styles.link}`} to={this.createLink(next)}>
            Next &#8250;
          </Link>
        </li>
        <li className={`nav-item${visibility}`}>
          <Link className={`nav-link text-light ${styles.link}`} to={this.createLink(last)}>
            Last &raquo;
          </Link>
        </li>
      </>
    );
  }

  render() {
    const { refIsOpen, settingsIsOpen } = this.state;
    const [first, back, current, next, last] = this.getFbcnl();
    const lines = this.getLines();

    return (
      <nav className="navbar navbar-expand navbar-dark bg-dark">
        <div className="collapse navbar-collapse" id="controlPanel">
        </div>
      </nav>
    );
  }
}

ControlPanel.propTypes = {
  chunks: chunksType.isRequired,
  match: publicationMatchType.isRequired,
  fullQuery: queryType.isRequired,
  linkQuery: queryType.isRequired,
};

export default ControlPanel;
